import "./FieldServices.module.css";
import MainNavigationHeader from "@/reusable_sections/Header";
import OnsiteTechnicalSupport from "./sections/OnsiteTechnicalSupport";
import ServiceCapabilities from "./sections/ServiceCapabilities";
import ServiceInquiry from "./sections/ServiceInquiry";
import CorporateInformationFooter from "@/reusable_sections/Footer";
export default function FieldServicesPage() {
  return <div>
      <MainNavigationHeader />
      <OnsiteTechnicalSupport />
      <ServiceCapabilities />
      <ServiceInquiry />
      <CorporateInformationFooter />
    </div>;
}